import { useQueryClient } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";

import { useUpdateQuestionnaireContentMutation } from "../../../../api/mutations/questionnaries";
import { keys, useQuestionnaireContentQuery } from "../../../../api/queries/questionnaires";

// Basically that hook stands for easier mutation and data getting for questionnaire.
const useQuestionnaire = (forumId, questionnaireId) => {
  const queryClient = useQueryClient();
  const queryKey = useMemo(
    () => keys.getQuestionnaireContent({ forumId, questionnaireId }),
    [forumId, questionnaireId],
  );

  const { data, isLoading } = useQuestionnaireContentQuery({ forumId, questionnaireId });

  const { mutate: originalMutate, isLoading: isSaving } = useUpdateQuestionnaireContentMutation({
    onSuccess: () => {
      return queryClient.invalidateQueries(queryKey);
    },
  });

  const pages = useMemo(() => {
    return data?.data?.pages ?? [];
  }, [data]);

  const mutate = useCallback(
    (pages, options = {}) => {
      originalMutate({ forumId, questionnaireId, pages }, options);
    },
    [forumId, originalMutate, questionnaireId],
  );

  return {
    pages,
    isLoading,
    isSaving,
    mutate,
  };
};

export default useQuestionnaire;
